import type { FC, PropsWithChildren } from 'react';
import { DragDropProvider } from '@dnd-kit/react';

import type { UseDndProviderProps } from './types.ts';

export const DndProvider: FC<PropsWithChildren<UseDndProviderProps>> = ({ sensors, modifiers, onDragStart, onDragEnd, children }) => (
  <DragDropProvider sensors={sensors} modifiers={modifiers} onDragStart={onDragStart} onDragEnd={onDragEnd}>
    {children}
  </DragDropProvider>
);
